import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularNothingToShow: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_nothing-to-show"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="nothing-to-show icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M21.75 3C23.5449 3 25 4.45507 25 6.25V21.75C25 23.5449 23.5449 25 21.75 25H6.25C4.45507 25 3 23.5449 3 21.75V6.25C3 4.45507 4.45507 3 6.25 3H21.75ZM4.5 21.75C4.5 22.7165 5.2835 23.5 6.25 23.5H21.75C22.7165 23.5 23.5 22.7165 23.5 21.75V16.5H18.184C17.842 18.4209 16.2095 19.8953 14.215 19.9947L14 20C11.9808 20 10.2905 18.5919 9.85751 16.7041L9.81597 16.5H4.5V21.75ZM21.75 4.5H6.25C5.2835 4.5 4.5 5.2835 4.5 6.25V15H10.5C10.8797 15 11.1935 15.2822 11.2432 15.6482L11.25 15.75C11.25 17.2688 12.4812 18.5 14 18.5C15.5188 18.5 16.75 17.2688 16.75 15.75C16.75 15.3703 17.0322 15.0565 17.3982 15.0068L17.5 15H23.5V6.25C23.5 5.2835 22.7165 4.5 21.75 4.5Z" />
      </svg>
    </span>
  );
};

export { RegularNothingToShow };
